import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'antd';
import { withTranslation } from 'react-i18next';

import error from '../../assets/images/Error-image.png';
import styles from './ErrorImage.scss';

class ErrorImage extends Component {
  render() {
    const { t, errorHeading, errorMessage } = this.props;

    return (
      <div className={styles.container}>
        {errorMessage && (
          <div className={styles.container__message}>
            <Alert
              message={errorHeading}
              description={errorMessage}
              type="error"
              showIcon
            />
          </div>
        )}

        <img
          src={error}
          alt={t('image_alt')}
          className={styles.container__image}
        />
      </div>
    );
  }
}

ErrorImage.propTypes = {
  errorHeading: PropTypes.string,
  errorMessage: PropTypes.string,
  errorType: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation('error')(ErrorImage);
